<template>
  <div v-show="isLoaded" class="mMaridajeGold-container" v-observe-visibility="startAnimate">
    <div class="brush-background">
      <h2 class="mSection-title" :class="{animate: animate}">Maridaje</h2>
      <p class="mSection-subtitle" :class="{animate: animate}">Disfruta de los platillos ideales para maridar con Strongbow Gold, abriendo los sentidos a vivir su máximo sabor.</p>
    </div>
    <div class="img-container" >
      <img class="img-maridaje" :src="maridaje" alt="Maridaje Gold">
      <div class="stick"></div>
      <div class="point"></div>
    </div>
    <div class="mfeature feature-botana" v-observe-visibility="startAnimate1">
      <div class="yellow-box feature-botana"  :class="{animate: animate1}"></div>
      <h3 class="feature-title" :class="{animate: animate1}">Con <br>Botana</h3>
      <ul class="list-feature">
        <li>Papas fritas con toques ácidos y salados.</li>
        <br>
        <li>Aperitivos salados a base de cereal<br>
        <span class="highlight">(pan, galletas con toques de ajo, queso y hierbas)</span>.</li>
        <br>
        <li>Frutos secos ligeramente salados<br>
        <span class="highlight">(pistaches, almendras, nueces de la india)</span>.</li>
      </ul>
    </div>
    <div class="mfeature feature-quesos" v-observe-visibility="startAnimate2">
      <div class="yellow-box feature-quesos" :class="{animate: animate2}"></div>
      <h3 class="feature-title" :class="{animate: animate2}">Con <br>quesos</h3>
      <ul class="list-feature">
        <li>De textura y maduración suaves<br> (chévre y camembert).</li>
      </ul>
    </div>
    <div class="mfeature feature-fuertes" v-observe-visibility="startAnimate3">
      <div class="yellow-box feature-fuertes" :class="{animate: animate3}"></div>
      <h3 class="feature-title" :class="{animate: animate3}">Con platos fuertes</h3>
      <ul class="list-feature">
        <li>Mariscos frescos.</li>
        <li>Carpaccio de pescado o carne de res.</li>
        <li>Pescados y carnes blancas empanizadas.</li>
        <li>Embutidos o carnes frías con manzanas.</li>
        <li>Huevos, jamones acompañados de pan o cereales integrados.</li>
        <li>Salchichas condimentadas (a base de cerdo, o con mostaza o con sabores caramelizados).</li>
      </ul>
    </div>
    <div class="mfeature feature-postres" v-observe-visibility="startAnimate4">
      <div class="yellow-box feature-postres" :class="{animate: animate4}"></div>
      <h3 class="feature-title" :class="{animate: animate4}">Con <br>postres</h3>
      <ul class="list-feature">
        <li>Cualquier postre a base de frutas.</li>
      </ul>
    </div>
  </div>
</template>

<script>
import maridaje from "@/assets/gold-apple/1DX_0296.jpg"
import Bowser from "bowser"; 
import { mapGetters } from "vuex";
export default {
  name: "MaridajeGold",
  components: {},
  data() {
    return {
      animate: false,
      animate1: false,
      animate2: false,
      animate3: false,
      animate4: false,
      maridaje,
      isSafari: false
    };
  },
  computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible) {
      if(isVisible) {
        this.animate=true
      } 
    },
    startAnimate1(isVisible) {
      if(isVisible) {
        this.animate1=true
      }
    },
    startAnimate2(isVisible) {
      if(isVisible) {
        this.animate2=true
      }  
    },
    startAnimate3(isVisible) {
      if(isVisible) {
        this.animate3=true
      }
    },
    startAnimate4(isVisible) {
      if(isVisible) {
        this.animate4=true
      }
    },
  },
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/GoldApple/MaridajeGold.scss";
</style>
